import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=3833b4ca&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3833b4ca')) {
      api.createRecord('3833b4ca', component.options)
    } else {
      api.reload('3833b4ca', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=3833b4ca&", function () {
      api.rerender('3833b4ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26mCb7bH5dRMd/JS/imageCarousel.vue"
export default component.exports